export const ru = {
    'error-401': 'Нет прав для выполнения данной операции'
};
